import React, { useEffect, useState } from 'react';
import '../../common/css/reissueRequest.css';
import InvolReservation from './reservationNumber/involReservation';
import axios from 'axios';
import Cookies from 'js-cookie';
import SaveModal from '../modal/saveModal';

function ReissueRequestPage() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [isCheck, setIsCheck] = useState(true);
    const [regAgentName, setRegAgentName] = useState('');
    const [regAgentPhone, setRegAgentPhone] = useState('');
    const [reservations, setReservations] = useState([
        {
            air_pnr: '',
            tkt_number: '',
            org_flight: '',
            new_flight: '',
            tkt_email_address: '',
            freeMemo: '',
        },
    ]);

    useEffect(() => {
        const axiosData = async () => {
            try {
                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

                const response = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/invol/info`,
                    {
                        withCredentials: true,
                    },
                );
                setRegAgentName(response.data.userName);
                setRegAgentPhone(response.data.userPhone);
            } catch (error) {
                setModalContent(error?.response?.data?.message);
                setModalAction(() => () => (window.location.href = '/login'));
                setSaveStatus(false);            }
        };
        if (Cookies.get('isLogin')) {
            axiosData();
        } else {
            setModalContent('로그인 후 이용 가능한 서비스 입니다.');
            setModalAction(() => () => (window.location.href = '/login'));
            setSaveStatus(false);
        }
    }, []);

    const reservationAdd = () => {
        setReservations([
            ...reservations,
            {
                air_pnr: '',
                tkt_number: '',
                org_flight: '',
                new_flight: '',
                tkt_email_address: '',
                freeMemo: '',
            },
        ]);
    };

    // 예약 삭제
    const reservationRemove = () => {
        if (reservations.length > 1) {
            setReservations(reservations.slice(0, -1));
        }
    };

    // 입력 필드 변경 시 상태 업데이트
    const handleChange = (index, field, value) => {
        setReservations(
            reservations.map((reservation, i) =>
                i === index ? { ...reservation, [field]: value } : reservation,
            ),
        );
    };

    const handleSubmit = async () => {
        try {
            for (let i = 0; i < reservations.length; i++) {
                if (reservations[i].air_pnr === '') {
                    setModalContent('항공사 예약번호를 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].tkt_number === '') {
                    setModalContent('티켓번호를 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].org_flight === '') {
                    setModalContent('INVOL 영향편을 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].new_flight === '') {
                    setModalContent('변경 요청편을 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].tkt_email_address === '') {
                    setModalContent('티켓 수신 이메일 주소를 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                }
            }
            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }
            await axios.post(
                `${
                    isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/board/invol/request`,
                { reservations, isCheck },
                {
                    withCredentials: true,
                },
            );

            window.location.href = '/service/involreissuelist';

        } catch (error) {
            setModalContent(error.response.data.message);
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
        }
    };

    return (
        <div id='contents' className='contents'>
            <div class='subp_h_wrap'>
                <div class='subp_h_list subp_h_home'>
                    <div>서비스요청</div>
                    <div>INVOL 재발행 요청</div>
                    <div>요청하기</div>
                </div>
            </div>
            <div className='page_hgroup'>
                <h2 className='title'>INVOL 재발행 요청</h2>
            </div>
            <div className='table_wrap mb40'>
                <table
                    className='table_style4 bdt mb70'
                    cellPadding='0'
                    cellSpacing='0'
                    id='airCertInfoTbl'
                >
                    <colgroup>
                        <col style={{ width: '190px' }} />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>
                                <p className='essential'>담당자</p>
                            </th>
                            <td colSpan='3'>{regAgentName}</td>
                        </tr>
                        <tr>
                            <th>
                                <p className='essential'>휴대폰 번호</p>
                            </th>
                            <td colSpan='3'>
                                {regAgentPhone}
                                <label name='agreeSendSNS'>
                                    <input
                                        type='checkbox'
                                        name='agreeSendSNS'
                                        id='agreeSendSNS'
                                        className='agreeSendSNSInput'
                                        checked={isCheck}
                                        onClick={() => setIsCheck(!isCheck)}
                                    />
                                    답변등록 시 SMS 전송
                                </label>
                                <a className='editPhoneNum' href='/mypage'>
                                    (&nbsp;&nbsp;<i class='fa-solid fa-mobile-screen-button'></i>
                                    &nbsp;&nbsp;담당자 휴대폰번호 수정&nbsp;&nbsp;)
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className='btn_area reissue_area'>
                    <input
                        type='button'
                        id='plusPnrNum'
                        value='+ 예약번호 추가'
                        className='btn36 red sendAuthNumY mo-mt-btn'
                        style={{ height: '45px', lineHeight: 'unset' }}
                        onClick={reservationAdd}
                    />
                    <input
                        type='button'
                        id='minPnrNum'
                        value='- 예약번호 삭제'
                        className='btn36 red sendAuthNumY mo-mt-btn'
                        style={{ height: '45px', lineHeight: 'unset' }}
                        onClick={reservationRemove}
                    />
                </div>
                {reservations.map((data, index) => (
                    <InvolReservation
                        num={index}
                        data={data}
                        key={index}
                        handleChange={handleChange}
                    />
                ))}
            </div>
            <div className='btn_area'>
                <input
                    type='button'
                    id='sendRequest'
                    value='INVOL 재발행 요청하기'
                    onClick={handleSubmit}
                    className='btn46 blue'
                    style={{ width: '260px' }}
                />
            </div>
            <div class='title_wrap mt70' style={{ justifyContent: 'flex-start' }}>
                <h4>유의 사항</h4>
            </div>
            <table class='table_style3 bdt' cellpadding='0' cellspacing='0' id='privateInfoTbl'>
                <colgroup>
                    <col style={{ width: '100%' }} />
                </colgroup>
                <tbody>
                    <tr>
                        {/*prettier-ignore */}
                        <td className='infoTable' style={{padding:'10px'}}>
                            <strong className='fontWeight red'>※ TAX 및 차액이 추가 발생하지 않는 리루팅 케이스의 경우, 여행사에서 자체적으로 재발행을 진행하여 주시기 바랍니다.</strong><br />
                            <br />
                            <strong>1. INVOL 재발행 조건 및 상세 기준은 해당 영향편의 처리 지침을 확인하여 주시기 바랍니다.</strong><br />
                            <strong>2. INVOL 요청은 1회에 한해 접수 가능합니다.</strong><br />
                            <strong>3. 요청 상태가 '접수완료'일 경우, 영업일 기준 1~2일 내 발권이 진행될 예정입니다.</strong><br />
                            <strong>4. <span className='red' id='point' >[중요]</span> INVOL 재발행 이후, 일정 변경 또는 환불 접수는 필리핀항공 서울사무소(1544-1717)를 통해 진행하셔야 합니다. 이 점 사전에 안내하여 주시기 바랍니다.</strong><br />
                        </td>
                    </tr>
                </tbody>
            </table>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default ReissueRequestPage;
